module.exports = __webpack_public_path__ + "img/addiction-2.94a155c.jpeg";